import script from "./LivingPersonListItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./LivingPersonListItem.vue?vue&type=script&lang=ts&setup=true"

import "./LivingPersonListItem.vue?vue&type=style&index=0&id=0c461eac&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c461eac"]])

export default __exports__